import React from "react";

import noResults from "../../images/no-results.png";
import { NoResultsContainer } from "../../containers/AuditLogs/styles";

const NoResults = ({ children }) => {
  return (
    <NoResultsContainer>
      <img alt="logo" src={noResults} width="200px" />
      <h4>No results found</h4>
      {children}
    </NoResultsContainer>
  );
};

export { NoResults };
